module.exports = __webpack_public_path__ + "img/빅불.513a332b.jpg";